import { render, staticRenderFns } from "./ImagesSlider.vue?vue&type=template&id=c9f6b0c2"
import script from "./ImagesSlider.vue?vue&type=script&lang=js"
export * from "./ImagesSlider.vue?vue&type=script&lang=js"
import style0 from "./ImagesSlider.vue?vue&type=style&index=0&id=c9f6b0c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports